import InputTextArea from "../../staff/InputTextArea";
import { usePersonForm } from "./personForm/PersonFormContext";

const Education = () => {
  const { form, setField, touchField } = usePersonForm();
  
  return (
    <InputTextArea
        title="Education"
        placeholder="ex: University, Degree, Start Year, End Year, Notes"
        value={form.education ?? ""}
        onChange={e => setField("education", e)}
        onBlur={() => touchField("education")}
        maxChars={1500}
        showCharacterCount
        minHeightClassName="min-h-[200px]"
      />
  );
};

export default Education;